import React from 'react';

export interface TimeValueProps {
  minutes: number;
}

export default function TimeValue({ minutes }: TimeValueProps) {
  const hours24 = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const period = hours24 >= 12 ? 'PM' : 'AM';
  const hours12 = hours24 % 12 || 12;
  const formattedTime = `${hours12}${mins > 0 ? `:${mins.toString().padStart(2, '0')}` : ''}`;

  return (
    <>
      {formattedTime}
      <span className="text-[0.65em] font-semibold">{period}</span>
    </>
  );
}
